document.addEventListener('DOMContentLoaded', function () {
  const salonDataEl = document.getElementById('salon-data');
  const salonContainer = document.getElementById('salon-container');

  if (!salonDataEl || !salonContainer) return;

  /** JSON を安全に読み込み */
  let salons = [];
  try {
    salons = JSON.parse(salonDataEl.textContent);
  } catch (e) {
    console.error('サロンデータの読み込みエラー:', e);
    salonContainer.innerHTML = '<p>データの読み込みに失敗しました。</p>';
    return;
  }

  /** ▼ license の多い順に並び替え */
  salons.sort((a, b) => {
    const lenA = Array.isArray(a.license) ? a.license.length : 0;
    const lenB = Array.isArray(b.license) ? b.license.length : 0;
    if (lenB === lenA) return a.name.localeCompare(b.name);
    return lenB - lenA; // 多いものを先頭へ
  });

  /** カードHTMLを生成 */
  const listHTML = salons.map((salon) => {
    const line1 = [salon.prefecture_a, salon.address_a].filter(Boolean).join(' ');
    const line2 = [salon.prefecture_b, salon.address_b].filter(Boolean).join(' ');

    // ダミーの円形アイコン（true のときだけ出力）
    const isOffline = salon.offline === true || salon.offline === 'true';
    const isOnline = salon.online === true || salon.online === 'true';

    const icons = [
      isOffline ? `<span class="salon-chip chip-offline" aria-label="対面対応">
    <svg viewBox="0 0 24 24" width="20" height="20">
      <circle cx="12" cy="6" r="4" fill="currentColor"/>
      <path d="M12 12c-4 0-7 2-7 6v4h14v-4c0-4-3-6-7-6z" fill="currentColor"/>
    </svg>
  </span>` : '',
      isOnline ? `<span class="salon-chip chip-online" aria-label="オンライン対応">
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2">
      <rect x="2" y="3" width="20" height="14" rx="2"/>
      <path d="M8 21h8M12 17v4"/>
    </svg>
  </span>` : ''
    ].join('');


    return `
      <article class="salon-card" data-handle="${salon.handle}" tabindex="0">
        <header class="salon-card__header">
          <div class="salon-card__title-area">
            <h3 class="salon-name">${salon.name}</h3>
            ${salon.instructor ? `<p class="salon-instructor">${salon.instructor}</p>` : ''}
          </div>
          <div class="salon-icons">${icons}</div>
        </header>
        <div class="salon-card__body">
          ${line1 ? `<div class="salon-address"><span class="pref">${salon.prefecture_a || ''}</span> ${salon.address_a || ''}</div>` : ''}
          ${line2 ? `<div class="salon-address"><span class="pref">${salon.prefecture_b || ''}</span> ${salon.address_b || ''}</div>` : ''}
        </div>
      </article>
    `;
  }).join('');

  salonContainer.innerHTML = listHTML || '<p>公開中のサロンはありません。</p>';

  /** ▼ モーダル生成 ▼ */
  const modal = document.createElement('div');
  modal.classList.add('salon-modal');
  modal.innerHTML = `
  <div class="salon-modal__overlay"><!-- overlay --></div>
  <div class="salon-modal__content" role="dialog" aria-modal="true" aria-label="サロン詳細">
    <button class="salon-modal__close" aria-label="閉じる">&times;</button>
    <div class="salon-modal__body"><p>読み込み中...</p></div>
  </div>
`;
  document.body.appendChild(modal);

  const overlay = modal.querySelector('.salon-modal__overlay');
  const closeBtn = modal.querySelector('.salon-modal__close');
  const bodyEl = modal.querySelector('.salon-modal__body');

  function openModal() {
    modal.classList.add('is-active');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('is-active');
    bodyEl.innerHTML = ''; // 次回に備えてクリア
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  /* ✕ボタンで閉じる（← 直接ハンドラを付けるのがポイント） */
  closeBtn.addEventListener('click', closeModal);

  /* オーバーレイ（黒背景）クリックで閉じる */
  overlay.addEventListener('click', closeModal);

  /* Escキーで閉じる */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-active')) closeModal();
  });

  /* コンテンツ内クリックは外側にバブリングさせない（✕ボタンのハンドラは別付けなのでOK） */
  modal.querySelector('.salon-modal__content').addEventListener('click', (e) => e.stopPropagation());

  /** ▼ カードクリックで詳細読み込み（カード生成後に実行される位置に置く） */
  function bindSalonCardClicks() {
    document.querySelectorAll('.salon-card').forEach((card) => {
      card.addEventListener('click', async () => {
        const handle = card.dataset.handle;
        if (!handle) return;

        openModal();
        bodyEl.innerHTML = '<p>読み込み中...</p>';

        try {
          const res = await fetch(`/pages/salonlist/${handle}`);
          if (!res.ok) throw new Error('Failed to fetch page');

          const html = await res.text();
          const temp = document.createElement('div');
          temp.innerHTML = html;

          // mainタグまたはpage-width要素を抽出
          const main = temp.querySelector('main') || temp.querySelector('.page-width') || temp;

          // ① sectionやstyleタグを削除
          main.querySelectorAll('style').forEach(s => s.remove());
          main.querySelectorAll('script').forEach(s => s.remove());
          main.querySelectorAll('section[id^="shopify-section-"]').forEach(sec => {
            sec.removeAttribute('id'); // idを削除してCSSスコープを無効化
            sec.removeAttribute('data-section-id');
          });

          // ② 内包divとして挿入（背景白にラップ）
          bodyEl.innerHTML = `
    <div class="salon-modal__inner" style="background:#fff; border-radius:inherit;">
      ${main.innerHTML}
    </div>
  `;
        } catch (err) {
          console.error(err);
          bodyEl.innerHTML = '<p>読み込みエラーが発生しました。</p>';
        }

      });
    });
  }

  /* 初回レンダリング直後や、一覧HTML生成後に呼ぶ */
  bindSalonCardClicks();

  /* ============================================
     絞り込み機能
     ============================================ */

  // 絞り込みトグルボタン
  const filterToggle = document.querySelector('.filter-toggle');
  const filterPanel = document.getElementById('filter-panel');

  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', () => {
      const isExpanded = filterToggle.getAttribute('aria-expanded') === 'true';
      filterToggle.setAttribute('aria-expanded', !isExpanded);
      filterPanel.hidden = isExpanded;
    });
  }

  // 条件クリアボタン（両方のクリアボタンに対応）
  const filterClearButtons = document.querySelectorAll('.filter-clear');
  filterClearButtons.forEach(clearBtn => {
    clearBtn.addEventListener('click', () => {
      // 全てのチェックボックスを解除
      document.querySelectorAll('.filter-panel input[type="checkbox"]').forEach(cb => {
        cb.checked = false;
      });
      // 半選択状態をクリア
      document.querySelectorAll('.filter-chip.is-indeterminate').forEach(chip => {
        chip.classList.remove('is-indeterminate');
      });
      // フィルタリング実行（これでステータスも自動的に消える）
      applyFilters();
    });
  });

  // 地域チェックボックスの連動
  document.querySelectorAll('.region-check').forEach(regionCheckbox => {
    regionCheckbox.addEventListener('change', () => {
      const region = regionCheckbox.dataset.region;
      const prefCheckboxes = document.querySelectorAll(`input[name="prefecture"][data-region="${region}"]`);
      const isChecked = regionCheckbox.checked;

      // 地域内の全都道府県をチェック/解除
      prefCheckboxes.forEach(cb => {
        cb.checked = isChecked;
      });

      // 半選択状態を解除
      regionCheckbox.closest('.filter-chip').classList.remove('is-indeterminate');

      applyFilters();
    });
  });

  // 都道府県チェックボックスの変更時
  document.querySelectorAll('input[name="prefecture"][data-region]').forEach(prefCheckbox => {
    prefCheckbox.addEventListener('change', () => {
      updateRegionState(prefCheckbox.dataset.region);
      applyFilters();
    });
  });

  // 対面/オンラインチェックボックスの変更時
  document.querySelectorAll('input[name="mode"]').forEach(modeCheckbox => {
    modeCheckbox.addEventListener('change', applyFilters);
  });

  // ライセンスチェックボックスの変更時
  document.querySelectorAll('input[name="license"]').forEach(licCheckbox => {
    licCheckbox.addEventListener('change', applyFilters);
  });

  // 海外チェックボックス（地域連動なし）
  const overseasCheckbox = document.querySelector('input[name="prefecture"][value="海外"]');
  if (overseasCheckbox) {
    overseasCheckbox.addEventListener('change', applyFilters);
  }

  // 地域の状態を更新（全選択/一部選択/未選択）
  function updateRegionState(region) {
    const regionCheckbox = document.querySelector(`.region-check[data-region="${region}"]`);
    const prefCheckboxes = document.querySelectorAll(`input[name="prefecture"][data-region="${region}"]`);
    const regionChip = regionCheckbox.closest('.filter-chip');

    const checkedCount = Array.from(prefCheckboxes).filter(cb => cb.checked).length;
    const totalCount = prefCheckboxes.length;

    if (checkedCount === 0) {
      // 未選択
      regionCheckbox.checked = false;
      regionChip.classList.remove('is-indeterminate');
    } else if (checkedCount === totalCount) {
      // 全選択
      regionCheckbox.checked = true;
      regionChip.classList.remove('is-indeterminate');
    } else {
      // 一部選択（半選択状態）
      regionCheckbox.checked = false;
      regionChip.classList.add('is-indeterminate');
    }
  }

  // フィルタリング実行
  function applyFilters() {
    // 対面/オンラインの条件取得
    const offlineChecked = document.querySelector('input[name="mode"][value="offline"]')?.checked;
    const onlineChecked = document.querySelector('input[name="mode"][value="online"]')?.checked;

    // 都道府県の条件取得（海外含む）
    const selectedPrefectures = Array.from(
      document.querySelectorAll('input[name="prefecture"]:checked')
    ).map(cb => cb.value);

    // ライセンスの条件取得
    const selectedLicenses = Array.from(
      document.querySelectorAll('input[name="license"]:checked')
    ).map(cb => cb.value);

    // 全カードを取得
    const cards = document.querySelectorAll('.salon-card');

    cards.forEach(card => {
      const handle = card.dataset.handle;
      const salon = salons.find(s => s.handle === handle);
      if (!salon) return;

      let showCard = true;

      // 対面/オンライン条件（AND条件）
      if (offlineChecked || onlineChecked) {
        const hasOffline = salon.offline === true || salon.offline === 'true';
        const hasOnline = salon.online === true || salon.online === 'true';

        if (offlineChecked && onlineChecked) {
          // 両方チェック → 両方対応している教室のみ
          showCard = hasOffline && hasOnline;
        } else if (offlineChecked) {
          // 対面のみ
          showCard = hasOffline;
        } else if (onlineChecked) {
          // オンラインのみ
          showCard = hasOnline;
        }
      }

      // 都道府県条件（OR条件）
      if (showCard && selectedPrefectures.length > 0) {
        const prefA = salon.prefecture_a || '';
        const prefB = salon.prefecture_b || '';

        // prefecture_a または prefecture_b が選択された都道府県に含まれるか
        const matchesPref = selectedPrefectures.some(pref =>
          prefA === pref || prefB === pref
        );

        showCard = matchesPref;
      }

      // ライセンス条件（AND条件）
      if (showCard && selectedLicenses.length > 0) {
        const salonLicenses = Array.isArray(salon.license) ? salon.license : [];

        // 選択された全てのライセンスをサロンが持っているか
        const hasAllLicenses = selectedLicenses.every(lic =>
          salonLicenses.includes(lic)
        );

        showCard = hasAllLicenses;
      }

      // 表示/非表示を切り替え
      card.style.display = showCard ? '' : 'none';
    });

    // 表示されているカードの数をカウント
    const visibleCount = Array.from(cards).filter(
      card => card.style.display !== 'none'
    ).length;

    // 件数表示を更新
    const resultNumber = document.querySelector('.result-number');
    if (resultNumber) {
      resultNumber.textContent = visibleCount;
    }

    // チェックボックスが1つでもチェックされているか確認
    const hasActiveFilters = document.querySelectorAll(
      '.filter-panel input[type="checkbox"]:checked'
    ).length > 0;

    // ステータス表示の表示/非表示を切り替え
    const filterStatus = document.querySelector('.filter-status');
    if (filterStatus) {
      filterStatus.style.display = hasActiveFilters ? 'flex' : 'none';

      // ★追加：表示した直後に位置を調整
      if (hasActiveFilters) {
        adjustFilterStatusPosition();
      }
    }
  }
  /* ============================================
     検索結果ステータスのスクロール対応
     ============================================ */

  // ヘッダーの高さ変化に対応
  function adjustFilterStatusPosition() {
    const filterStatus = document.querySelector('.filter-status');
    if (!filterStatus || filterStatus.style.display === 'none') return;

    // ページ上部からのスクロール量
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // スクロール位置に応じて位置を調整
    if (scrollTop < 100) {
      // ページトップ付近：ヘッダーが大きい状態
      filterStatus.style.top = window.innerWidth <= 768 ? '160px' : '160px';
    } else {
      // スクロール後：ヘッダーが小さい状態
      filterStatus.style.top = window.innerWidth <= 768 ? '90px' : '100px';
    }
  }

  // スクロールイベント監視（パフォーマンス考慮）
  let scrollTimeout;
  window.addEventListener('scroll', () => {
    if (scrollTimeout) {
      window.cancelAnimationFrame(scrollTimeout);
    }
    scrollTimeout = window.requestAnimationFrame(adjustFilterStatusPosition);
  }, { passive: true });

  // リサイズ時も調整
  window.addEventListener('resize', adjustFilterStatusPosition);

  // Handle Back-Forward Cache (bfcache) and initial load
  window.addEventListener('pageshow', function (event) {
    // Re-apply filters whenever the page is shown (load or back/forward)
    applyFilters();
  });

  // Handle URL parameters for initial filtering
  function applyUrlFilters() {
    const params = new URLSearchParams(window.location.search);

    // License filter
    const licenseParam = params.get('license');
    if (licenseParam) {
      const checkbox = document.querySelector(`input[name="license"][value="${licenseParam}"]`);
      if (checkbox) {
        checkbox.checked = true;
        // Expand the license section if needed
        const details = checkbox.closest('details');
        if (details) details.open = true;
      }
    }

    // Prefecture filter
    const prefectureParam = params.get('prefecture');
    if (prefectureParam) {
      const checkbox = document.querySelector(`input[name="prefecture"][value="${prefectureParam}"]`);
      if (checkbox) {
        checkbox.checked = true;
        const region = checkbox.dataset.region;
        if (region) updateRegionState(region);
        // Expand the region section if needed
        const details = checkbox.closest('details');
        if (details) details.open = true;
      }
    }

    // Mode filter
    const modeParam = params.get('mode');
    if (modeParam) {
      const checkbox = document.querySelector(`input[name="mode"][value="${modeParam}"]`);
      if (checkbox) checkbox.checked = true;
    }
  }

  // Initial call
  applyUrlFilters();
  applyFilters();
  adjustFilterStatusPosition();
});
